import type { Middleware } from '@reduxjs/toolkit';
import type { BuiltAction, WsCommand } from '@skynet/data-ws-core';
import { isRecord } from 'src/utils/type-guards';

import { wsEsSend, wsEsChannel } from '@skynet/data-ws-es';
import { wsMmSend, wsMmChannel } from '@skynet/data-ws-mm';

function isBuiltAction(action: unknown): action is BuiltAction<WsCommand> {
  return isRecord(action) && 'meta' in action && 'type' in action && isRecord(action.meta);
}

const handleWsRequestMiddleware: Middleware = (store) => (next) => (action) => {
  if (!isBuiltAction(action)) {
    return next(action);
  }

  const typedAction = action;

  if (typedAction.meta?.ws) {
    let actionCreator: typeof wsMmSend;
    switch (typedAction.meta.ws) {
      case wsMmChannel: {
        actionCreator = wsMmSend;
        break;
      }
      case wsEsChannel: {
        actionCreator = wsEsSend;
        break;
      }
      default:
        return next(typedAction);
    }

    store.dispatch(
      actionCreator({
        ...typedAction.payload!,
      }),
    );
  }
  return next(typedAction);
};

export default handleWsRequestMiddleware;
